<template>
  <div>
    
    <div class="loading-cover" :class="{ hidden: db || !landingPage.length }">
      <vue-loaders-line-scale color="black" />
    </div>
    <div v-if="db || !landingPage.length" class="body">
      <nav
        id="#"
        class="nav-wrapper"
        :style="'background:' + landingPage.themeColor"
      >
        <div class="top-wrapper w-clearfix">
          <div class="top-logo-wrap">
            <img
              v-if="landingPage.logo"
              :src="landingPage.logo.imageURL"
              loading="lazy"
              alt
            />
          </div>
          <div class="dark-bg" @click="menu()" :class="{ active: open }">
            <div
              class="nav-menu"
              :class="{ active: open }"
              :style="'background-color:' + landingPage.themeColor"
            >
              <div class="close-menu-wrapper">
                <a href="#" class="close-menu"></a>
              </div>
              <a
                v-for="(menu, i) in menuItems"
                :key="i"
                :href="
                  menu.scrollTo && menu.scrollTo.length
                    ? '#' + menu.scrollTo[0].itemRefID
                    : linkinfy(menu.externalLink)
                "
                :target="menu.scrollTo && menu.scrollTo.length ? '' : '_blank'"
                class="nav-link"
                :class="{ highlight: menu.highlight }"
                :style="{
                  color: menu.highlight
                    ? landingPage.themeColor
                    : landingPage.negativeColor,
                  'background-color': menu.highlight
                    ? landingPage.negativeColor
                    : '',
                }"
                >{{ menu.title }}</a>
            </div>
          </div>
          <p
            class="burger"
            @click="menu()"
            :style="'color:' + landingPage.negativeColor"
          >
            
          </p>
        </div>
      </nav>
      <div class="top empty">
        <div
          class="vid-wrap"
          :class="{ 'no-donate': landingPage.donationBox == false && !landingPage.chatEnabled,'vid-background': landingPage.overlayVideo && landingPage.videoOverlay && landingPage.videoOverlay.imageURL.match(/mp4|mpeg|avi/) }"
        >
          <div
            class="relativsitic"
            :class="{ 'w-col-8': landingPage.donationBox != false || landingPage.chatEnabled}"
          >
            <bgl-embed
              v-if="landingPage.mainVideo"
              class="embed"
              :overlay="
                landingPage.overlayVideo ? landingPage.videoOverlay : ''"
              :cc="landingPage.ccVideo"
              :src="landingPage.mainVideo"
            />
            <marquee-text :duration="30">
              {{ landingPage.marquee }}
            </marquee-text>
          </div>
          <chat :landingPage="landingPage" :registrationFields="registrationFields" v-if="landingPage.chatEnabled && !status && registrationFields" class="donation-box"/>
          <donation-box
            v-else-if="landingPage.donationBox===true && db"
            :landingPage="landingPage"
          />
        </div>
        <div
          v-if="landingPage.coverImage"
          class="main-image-wrapper"
          :style="{
            'background-image': 'url(' + landingPage.coverImage.imageURL + ')',
          }"
        >
          <div class="main-image-grad" />
          <img
            :src="landingPage.heroImage.imageURL"
            v-if="landingPage.heroImage"
            width="500"
            alt
            class="main-image"
          />
        </div>
      </div>
      <component
        :landingPage="landingPage"
        :id="section._id"
        style="text-align: center"
        v-for="(section, i) in sections"
        :key="i"
        :is="section.sectionType.value"
        :value="section"
      />
      <a href="#" class="scroll-top" :class="{ visible: scrollToTop }">⤑</a>
      <popup
        :bgColor="landingPage.blockSite ? 'white' : ''"
        :forced="true"
        v-model="registrationPopup"
      >
        <register
          :db="db"
          :registrationFields="registrationFields"
          v-if="landingPage && db && registrationFields"
          :landingPage="landingPage"
          @close="closeRegustration()"
        />
      </popup>
      
    </div>
  </div>
</template>

<style scoped>
.scroll-top {
  width: 40px;
  height: 40px;
  transform: rotate(-90deg);
  cursor: pointer;
  background: black;
  padding: 5px;
  position: fixed;
  right: -130px;
  bottom: 20px;
  transition: all ease 0.2s;
  color: white;
  border-radius: 100%;
  z-index: 2;
  text-decoration: none;
}
.scroll-top:hover {
  filter: brightness(120);

  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}
.scroll-top.visible {
  right: 20px;
}
</style>


<script>
import DonationBox from "../components/Donation-Box";
import Profiles from "../components/Profiles";
import Program from "../components/Program";
import Sponsers from "../components/Sponsers";
import InfoBox from "../components/Info-Box";
import Gallery from "../components/Gallery";
import LinkBox from "../components/Link-Box";
import BigText from "../components/Big-Text";
import register from "../components/register";
import CustomHTML from "../components/Custom-HTML";
import SponsersText from "../components/Sponsers-Text";
import bglEmbed from "../components/bgl-embed";
import marquee from "../components/marquee";
import FooterStripe from "../components/Footer-Stripe";
import chat from "../components/chat";
import Bagel from "@bageldb/bagel-db";

export default {
  metaInfo: {
    title: "Tina's wish",
  },
  // eslint-disable-next-line
  components: {
    chat,
    marquee,
    Program,
    Sponsers,
    Profiles,
    InfoBox,
    DonationBox,
    LinkBox,
    BigText,
    register,
    CustomHTML,
    FooterStripe,
    SponsersText,
    bglEmbed,
    Gallery,
  },
  data() {
    return {
      resetChat:false,
      status: false,
      registrationPopup: false,
      landingPage: {},
      scrollToTop: false,
      db: "",
      site: "tabc",
      openDonation: false,
      open: false,
      menuItems: [],
      sections: [],
      registrationFields:null,
    };
  },
  async mounted() {
    this.$cookies.config("30d");
    if (
      window.location.href.replace(/https:\/\//, "").split(".").length == 2 ||
      (window.location.href.match("netlify") &&
        !window.location.href.match("192.168"))
    ) {
      this.site = window.location.href.replace(/https:\/\//, "").split(".")[0];
    } else if (!window.location.href.match("192.168")) {
      this.site = window.location.href.replace(/https:\/\//, "").split(".")[1];
    }
    this.db = new Bagel(process.env.VUE_APP_BAGEL_TOKEN);
    // let single = await this.db.collection("sponsorships").perPage(1).get();
    // console.log(JSON.stringify(single.data));
    let { data } = await this.db.collection("landingPage").everything().get();
    this.landingPage = data[0];
    if (
      (!this.$cookies.get(this.landingPage._id) &&
        !this.landingPage.disablePopup) ||
      (this.landingPage.blockSite && !this.$route.query.nopopup)
    ) {
      this.registrationPopup = true;
    }
  let {data:registrationFields} = await this.db.schema("registrations").get()
  console.log(registrationFields)
  this.registrationFields = registrationFields;

  if (this.landingPage.customFontTitles){
    let customCSS = `.program-txt, body,.top-box,.button,.sponsorship-small-head, .sec-head, .prog-wrap, .mer-20,.party-link {font-family:${this.landingPage.customFontTitles.value}}`
    this.injectStyle(customCSS)
  }
    // if (this.site == "tinaswishbenefit") {
    //   this.landingPage.donationURL =
    //     "https://tayment.com/donationLinkShortCode/68";
    //   this.landingPage.chatUrl = "https://tayment.com/messages-stream/68/1631";
    // }

    let menu = await this.db.collection("menuItems").sort("order").get();
    this.menuItems = menu.data;
    let sections = await this.db
      .collection("sections")
      .everything()
      .query("draft", "!=", true)
      .sort("order")
      .get();
    this.sections = sections.data;

    this.setMetadata();
    this.scrollListener();
  },
  methods: {
    injectStyle(rule){      
      let css = document.createElement('style');
      css.type = 'text/css';
      if (css.styleSheet) css.styleSheet.cssText = rule; // Support for IE
      else css.appendChild(document.createTextNode(rule)); // Support for the rest
      document.getElementsByTagName("head")[0].appendChild(css);
    },
    linkinfy(link) {
      if (!link) return "";
      if (link.match("//")) return link;
      return "//" + link;
    },
    closeRegustration() {
      this.registrationPopup = false;
      this.status = true;
      setTimeout(() => (this.status = false), 1400);
    },
    scrollListener() {
      window.addEventListener("scroll", () => {
        if (window.outerHeight * 0.7 < window.scrollY) {
          this.scrollToTop = true;
        } else {
          this.scrollToTop = false;
        }
      });
    },
    setMetadata() {
      if (this.landingPage.favicon) {
        let fav = document.createElement("link");
        fav.rel = "icon";
        fav.href = this.landingPage.favicon.imageURL;
        document.head.appendChild(fav);
      }
      document.title = this.landingPage.title || "";
    },
    menu() {
      this.open = !this.open;
    },
  },
};
</script>
